/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';
import 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio.js';

/**
 * Internal Dependencies
 */
import '@/utils/100vh';
import '@/utils/faIcons';
import CONFIG from '@/core/config';
import scrollHeader from '@/common/scrollHeader';
import mainMenu from '@/common/mainMenu';
import videoControls from '@/common/videoControls';

$(() => {
	scrollHeader.init($('.js-header'));
	mainMenu.init($('.js-menu-toggle'));
	videoControls.init($('.js-video-controls'));
});

window['console']['log'](`%c${CONFIG.COPYRIGHT}`, 'padding:1px;background-color:#fff;color:#000;font-family:courier,monospace;font-size:12px;');